import axios from 'axios'
import { formatTime } from '../../util/index'
import { http } from '@/api/http'

const track = {
  state: {
    waybills: [],
    inputTrackingNumber: '',
    notExistsTrackingNumbers:[],
    stateContinents: [],
    stateCountries: [],
    stateProducts: [],
    stateWeightRestriction:'',
    stateSizeRestriction:'',
    stateValueRestrictionTerms:'',
    stateGeneralTerm: ''
  },
  mutations:{
    CLICK_SEARCH:(state,tracking) => {
      state.waybills = tracking.waybills;
      state.inputTrackingNumber = tracking.inputTrackingNumber;
      state.notExistsTrackingNumbers = tracking.notExistsTrackingNumbers;
    },
    CONTINENT_LIST:(state,list) => {
      state.stateContinents = list;
      state.stateCountries = [];
      state.stateProducts = [];
    },
    COUNTRY_LIST:(state,list) => {
      state.stateCountries = list;
    },
    PRODUCT_LIST:(state,list) => {
      state.stateProducts = list;
    },
    RESTRICTION:(state,restriction) => {
      state.stateWeightRestriction = restriction.weightRestriction;
      state.stateSizeRestriction = restriction.sizeRestriction;
      state.stateValueRestrictionTerms = restriction.valueRestrictionTerms;
    },
    GENERAL_TERM:(state,generalTerm) => {
      state.stateGeneralTerm = generalTerm.generalTerm;
    }
  },
  actions: {
    getTrackingList: ({ commit },params) => {
      return new Promise((resolve, reject)=>{
        http.mergePostAndPut(process.env.BASE_API + '/capricorn-website/website/v1/tracking/traces',params)
          .then(function (response) {
            // console.log(response)
            if(response.success && response.result){
              let language = params['language'];
              const trackingList = response.result.waybills
              const notExistsTrackingNumbers = response.result.notExistsTrackingNumbers
              if (trackingList && Array.isArray(trackingList)) {
                let inputTrackingNumber;
                params.trackingNumbers.forEach(trackNumber =>{
                  if (inputTrackingNumber) {
                    inputTrackingNumber = `${inputTrackingNumber}${trackNumber}\n`
                  } else {
                    inputTrackingNumber = `${trackNumber}\n`
                  }
                })
                trackingList.forEach((value, index, array)=>{
                  let singleTrackingTraces = [];
                  let dailyFormattedTrace = {};
                  let lastDay;
                  value.traces.forEach((trace, index) => {
                    if (formatTime(trace.oprTimestamp,1) === lastDay) {
                      trace.formatedTime = formatTime(trace.oprTimestamp, 0);
                      trace.formatedDate =  formatTime(trace.oprTimestamp,2);

                      singleTrackingTraces[singleTrackingTraces.length - 1].timeTraces.push(trace)
                    } else {
                      dailyFormattedTrace = {};
                      lastDay = formatTime(trace.oprTimestamp,1);
                      dailyFormattedTrace.day = lastDay;
                      let timeTraces = [];
                      trace.formatedTime = formatTime(trace.oprTimestamp, 0);
                      trace.formatedDate =  formatTime(trace.oprTimestamp,2);

                      timeTraces.push(trace);
                      dailyFormattedTrace.timeTraces = timeTraces;
                      singleTrackingTraces.push(dailyFormattedTrace)
                    }
                    //6576需求新增国际化
                    if(language==='en-US'){
                      trace.eventDescGlobal = trace.eventDesc;
                      trace.oprCityGlobal = trace.oprCity;
                      trace.oprCountryGlobal = trace.oprCountry;
                    }
                    if(language==='zh-CN'){
                      trace.eventDescGlobal = trace.eventDescCn;
                      trace.oprCityGlobal = typeof(trace.oprCityCn) == "undefined" ? trace.oprCity : trace.oprCityCn;
                      trace.oprCountryGlobal = typeof(trace.oprCountryCn) == "undefined" ? trace.oprCountry : trace.oprCountryCn;
                    }
                  });
                  if(language==='en-US'){
                    value.lastStatusGlobal = value.lastStatus;
                  }
                  if(language==='zh-CN'){
                    value.lastStatusGlobal = value.lastStatusCn;
                  }
                  value.formattedTraces = singleTrackingTraces;
                  value.formattedLastTime = formatTime(value.lastTimestamp, 0)
                    +'   '
                    // + ' (UTC' + (value.lastTimeZone >= 0 ? '+' + value.lastTimeZone : value.lastTimeZone) +') '
                    + formatTime(value.lastTimestamp, 1);
                });
                commit('CLICK_SEARCH',{ 'waybills' : trackingList,'notExistsTrackingNumbers': notExistsTrackingNumbers, 'inputTrackingNumber': inputTrackingNumber})
                return resolve({ 'waybills' : trackingList,'notExistsTrackingNumbers': notExistsTrackingNumbers, 'inputTrackingNumber': inputTrackingNumber})
              }
            } else {
              return reject()
            }
          }).catch(error=> {
          return reject()
        })
      })
    },
    loadContinents: ({ commit },params) => {
      return new Promise((resolve, reject)=>{
        let ret = [];
        commit('CONTINENT_LIST', ret);
        http.get(process.env.BASE_API + '/capricorn-website/website/v1/continents',{'type':1})
          .then(function (response) {
            if(response.success && response.result){
              let language = params['language'];
              let list = response.result;
              for (let item of list){
                let label = '-';
                for(let proper in item){
                  if(language==='en-US' && /^.*En$/.test(proper)){
                    label=item[proper];
                  }
                  if(language==='zh-CN' && /^.*Cn$/.test(proper)){
                    label=item[proper];
                  }
                }
                let obj = {'value': item.code, 'label': label};
                ret.push(obj)
              }
              commit('CONTINENT_LIST', ret);
              return resolve(ret)
            } else {
              return reject()
            }
          }).catch(error=> {
            reject(error);
            console.error(error)
        })
      })
    },
    loadCountries: ({ commit },params) => {
      return new Promise((resolve, reject)=>{
        let ret = [];
        if (!params) {
          commit('COUNTRY_LIST', ret);
          return resolve(ret);
        }
        http.get(process.env.BASE_API + '/capricorn-website/website/v1/countries',params['reqParam'])
          .then(function (response) {
            if(response.success && response.result){
              let language = params['language'];
              let list = response.result;
              for (let item of list){
                let label = '-';
                for(let proper in item){
                  if(language==='en-US' && /^.*En$/.test(proper)){
                    label=item[proper];
                  }
                  if(language==='zh-CN' && /^.*Cn$/.test(proper)){
                    label=item[proper];
                  }
                }
                let obj = {'value': item.code, 'label': label};
                ret.push(obj)
              }
              commit('COUNTRY_LIST', ret);
              return resolve(ret)
            } else {
              return reject()
            }
          }).catch(error=> {
          reject(error);
          console.error(error)
        })
      })
    },
    loadProducts: ({ commit },params) => {
      return new Promise((resolve, reject)=>{
        let ret = [];
        if (!params) {
          commit('PRODUCT_LIST', ret);
          return resolve(ret);
        }
        http.get(process.env.BASE_API + '/capricorn-website/website/v1/products',params['reqParam'])
          .then(function (response) {
            if(response.success && response.result){
              let language = params['language'];
              let list = response.result;
              for (let item of list){
                let label = '-';
                for(let proper in item){
                  if(language==='en-US' && /^.*En$/.test(proper)){
                    label=item[proper];
                  }
                  if(language==='zh-CN' && /^.*Cn$/.test(proper)){
                    label=item[proper];
                  }
                }
                let obj = {'value': item.code, 'label': label};
                ret.push(obj)
              }
              commit('PRODUCT_LIST', ret);
              return resolve(ret)
            } else {
              return reject()
            }
          }).catch(error=> {
          reject(error);
          console.error(error)
        })
      })
    },
    loadRestriction: ({ commit },params) => {
      return new Promise((resolve, reject)=>{
        let ret = {};
        if (!params) {
          commit('RESTRICTION', ret);
          commit('GENERAL_TERM', ret);
          return resolve(ret);
        }
        http.get(process.env.BASE_API + '/capricorn-website/website/v1/restriction',params['reqParam'])
          .then(function (response) {
            if(response.success && response.result){
              let language = params['language'];
              let result = response.result;
              if (result.restriction){
                let restriction = result.restriction;
                for(let proper in restriction){
                  if (proper.indexOf('weightRestriction')>= 0){
                    if(language==='en-US' && /^.*En$/.test(proper)){
                      ret['weightRestriction']=restriction[proper];
                    }
                    if(language==='zh-CN' && /^.*Cn$/.test(proper)){
                      ret['weightRestriction']=restriction[proper];
                    }
                  }
                  if (proper.indexOf('sizeRestriction')>= 0){
                    if(language==='en-US' && /^.*En$/.test(proper)){
                      ret['sizeRestriction']=restriction[proper];
                    }
                    if(language==='zh-CN' && /^.*Cn$/.test(proper)){
                      ret['sizeRestriction']=restriction[proper];
                    }
                  }
                  if (proper.indexOf('valueRestrictionTerms')>= 0){
                    if(language==='en-US' && /^.*En$/.test(proper)){
                      ret['valueRestrictionTerms']=restriction[proper];
                    }
                    if(language==='zh-CN' && /^.*Cn$/.test(proper)){
                      ret['valueRestrictionTerms']=restriction[proper];
                    }
                  }
                }
              }
              commit('RESTRICTION', ret);
              if (result.generalTerm){
                let generalTerm = result.generalTerm;
                for(let proper in generalTerm){
                  if(language==='en-US' && /^.*En$/.test(proper)){
                    ret['generalTerm']=generalTerm[proper];
                  }
                  if(language==='zh-CN' && /^.*Cn$/.test(proper)){
                    ret['generalTerm']=generalTerm[proper];
                  }
                }
              }
              commit('GENERAL_TERM', ret);
              return resolve(ret)
            } else {
              return reject()
            }
          }).catch(error=> {
          reject(error);
          console.error(error)
        })
      })
    },
    districtsTree: ({ commit },params) => {
      return new Promise((resolve, reject)=>{
        http.get(process.env.BASE_API + '/capricorn-website/website/v1/districts/tree',params)
          .then(function (res) {
            if (res.result) {
              const result = res.result
              if (result.version) {
                localStorage.setItem('districtsVersionNo2', result.version)
              }
              if (result.countrys && result.countrys.length > 0) {
                localStorage.setItem('country2', JSON.stringify(result.countrys))
              }
              if (result.provinces && result.provinces.length > 0) {
                localStorage.setItem('province2', JSON.stringify(result.provinces))
              }
              if (result.citys && result.citys.length > 0) {
                localStorage.setItem('city2', JSON.stringify(result.citys))
              }
              if (result.all && result.all.length > 0) {
                localStorage.setItem('all2', JSON.stringify(result.all))
              }
              resolve()
            }
        })
      })
    },
    districtsTreeSubset: ({ commit },params) => {
      return new Promise((resolve, reject)=>{
        http.get(process.env.BASE_API + '/capricorn-website/website/v1/districts/tree-subset',params)
          .then(function (res) {
            if (res.result && res.result.length > 0 && !res.hasBusinessException) {
              const districtTreeSubset = res.result
              resolve({ 'districtTreeSubset':districtTreeSubset})
            }
          })
      })
    },
    priceEstimateCalculate:({ commit },params) => {
      return new Promise((resolve, reject)=>{
        http.get(process.env.BASE_API + '/capricorn-website/website/v1/price-estimate/estimate',params)
          .then(function (res) {
            // if (res.result && res.result.length > 0 && !res.hasBusinessException) {
            if (res.success){
              const data = res.result
              // resolve({ 'priceEstimateCalculateResult':data.one,'success':true})
              // resolve({ 'priceEstimateCalculateResult':data.zero,'success':true})
              resolve({ 'priceEstimateCalculateResult':res,'success':true})
            } else {
              resolve({ 'success':false, 'errorMsg':res.errorMsg})
            }
          })
      })
    },
    priceEstimateCalculate2:({ commit },params) => {
      return new Promise((resolve, reject)=>{
        http.get(process.env.BASE_API + '/capricorn-website/website/v1/price-estimate/estimate',params)
          .then(function (res) {
            // if (res.result && res.result.length > 0 && !res.hasBusinessException) {
            if (res.success){
              const data = res.result
              if (data.one){
                resolve({ 'priceEstimateCalculateResult':data.one,'success':true})
              }
              if (data.zero && !data.one){
                resolve({ 'success':false, 'errorMsg':'输入的邮编找不到价卡'})
              }
              if(!data.zero){
                resolve({ 'success':false, 'errorMsg':'找不到价卡'})
              }
            } else {
              resolve({ 'success':false, 'errorMsg':res.errorMsg})
            }
          })
      })
    },
    queryPriceAreaByType: ({ commit },params) => {
      return new Promise((resolve, reject)=>{
        console.log('param',params)
        http.get(process.env.BASE_API + '/capricorn-website/website/v1/price/area/'+params.type)
          .then(function (res) {
            if (res && res.result && res.result.length > 0){
              let list = []
              res.result.forEach(item => {
                if (item && item.value) {
                  let displayN = item.displayName
                  /*if (displayN === '法罗群岛'){
                    displayN = '法罗群岛（法国）'
                  }*/
                  list.push({
                    value: item.sectionNumber,
                    displayNameZh:displayN,
                    displayNameEn:item.displayNameUS

                  })
                }
              });
              localStorage.setItem('queryPriceArea', JSON.stringify(list))
            }
            resolve()
          })
      })
    },
  }
}
export default track;



// WEBPACK FOOTER //
// ./src/store/modules/track.js